import React, { useState } from "react"
import PropTypes from "prop-types"
import loadingGif from "../../images/loading.gif"
import {
  deliberationsContainer,
  deliberationsYearWrapper,
  deliberationsMonthList,
  deliberationsDocumentList,
  deliberationsLoadingWrapper,
  deliberationsLoadingSpinner,
} from "./deliberations.module.scss"
import { MonthFilter, YearFilter } from "./deliberations-styled.js"

const Deliberations = ({ deliberationsData }) => {
  const [selectedAnnee, setSelectedAnnee] = useState(null)
  const [selectedMonth, setSelectedMonth] = useState(null)

  return (
    <div>
      <div>
        {!deliberationsData && (
          <div className={deliberationsLoadingWrapper}>
            <img
              alt="loading gif"
              src={loadingGif}
              className={deliberationsLoadingSpinner}
            />
            <span>Chargement des données...</span>
          </div>
        )}
        {deliberationsData &&
          (!Object.keys(deliberationsData).length ? (
            <span>Aucune délibération présente</span>
          ) : (
            <>
              <div className={deliberationsYearWrapper}>
                {Object.keys(deliberationsData).map((annee, index) => (
                  <YearFilter
                    key={index}
                    onClick={() => {
                      setSelectedAnnee(annee)
                    }}
                    active={annee === selectedAnnee}
                    className="btn"
                  >
                    {parseInt(annee)}
                  </YearFilter>
                ))}
              </div>

              {!selectedAnnee ? (
                <span>Veuillez sélectionner une année</span>
              ) : (
                !selectedMonth && <span>Veuillez sélectionner un mois</span>
              )}

              {Object.keys(deliberationsData).map(
                (annee, index) =>
                  selectedAnnee === annee && (
                    <div key={index} className={deliberationsContainer}>
                      {deliberationsData[annee] && (
                        <>
                          <div className={deliberationsMonthList}>
                            {Object.keys(deliberationsData[annee]).map(
                              (mois, indexMois) => {
                                const date = new Date()
                                date.setMonth(mois - 1)
                                const labelMois = date.toLocaleString("fr-FR", {
                                  month: "long",
                                })
                                return (
                                  <MonthFilter
                                    key={indexMois}
                                    onClick={() => setSelectedMonth(mois)}
                                    active={mois === selectedMonth}
                                  >
                                    {labelMois}
                                  </MonthFilter>
                                )
                              }
                            )}
                          </div>
                          <ul className={deliberationsDocumentList}>
                            {Object.keys(deliberationsData[annee]).map(
                              (mois, indexMois) =>
                                selectedMonth === mois &&
                                Object.keys(deliberationsData[annee][mois]).map(
                                  (jour, indexJour) =>
                                    deliberationsData[annee][mois][jour].map(
                                      (document, indexDocument) => {
                                        const date = new Date(document.date)
                                        date.setMonth(mois - 1)

                                        return (
                                          <li key={indexJour}>
                                            <a
                                              href={
                                                process.env
                                                  .GATSBYSIDE_DRUPAL_URL +
                                                document.path
                                              }
                                              target="_blank"
                                              rel="noreferrer"
                                            >
                                              {document.name}
                                            </a>{" "}
                                            {date.toLocaleString("fr-FR", {
                                              year: "numeric",
                                              month: "long",
                                              day: "numeric",
                                            })}
                                          </li>
                                        )
                                      }
                                    )
                                )
                            )}
                          </ul>
                        </>
                      )}
                    </div>
                  )
              )}
            </>
          ))}
      </div>
    </div>
  )
}

Deliberations.propTypes = {
  deliberationsData: PropTypes.object,
}

export default Deliberations
